export default __webpack_public_path__ + "static/media/225.f764dcd8.jpg";